import { motion } from "framer-motion";
import DepositFooter, { DepositFooterProps } from "./DepositFooter";
import DepositTitleHeader, { DepositTitleHeaderProps } from "./DepositTitleHeader";

interface DepositContainerProps {
	children: React.ReactNode;
	titleHeader?: DepositTitleHeaderProps;
	footer?: DepositFooterProps;
	showSkeleton?: boolean;
	skeleton?: React.ReactNode;
}
/**
 * 入金公用Container
 */
export default function DepositContainer(props: DepositContainerProps) {
	return (
		<motion.div
			className="flex flex-col justify-between h-full relative"
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			transition={{ duration: 1 }}
		>
			<div className="flex-1 overflow-y-auto hidden-scroll-bar">
				<DepositTitleHeader {...props.titleHeader} />
				{/* content */}
				{props.children}
			</div>

			{/* footer */}
			{props.footer && <DepositFooter {...props.footer} />}
			{/* skeleton */}
			{props.showSkeleton && (
				<div className="absolute left-0 top-0 w-full h-full z-10 bg-white dark:bg-dark">{props.skeleton}</div>
			)}
		</motion.div>
	);
}
